<template>
  <div>
    <el-card class="box-card">
      <el-form
        :model="score_info"
        :rules="rules"
        :inline="true"
      >
        <el-form-item label="系列" prop="cate1">
          <el-select
            v-model="score_info.cate1_id"
            placeholder="系列"
            @change="getCate2List"
          >
            <el-option
              v-for="item in cate1List"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品名" prop="cate2">
          <el-select v-model="score_info.cate2_id" placeholder="品名">
            <el-option
              v-for="item in cate2List"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="success" @click="insertScoreInfoVisable = true"
              >新增</el-button
            >
          </el-form-item>
      </el-form>

      <el-table :data="tableList" border stripe>
        <el-table-column label="id" prop="id" width="80"></el-table-column>
        <el-table-column label="系列" prop="cate2.cate1.name"></el-table-column>
        <el-table-column label="品名" prop="cate2.name"></el-table-column>
        <el-table-column label="分值" prop="score"></el-table-column>
        <el-table-column label="当前存量" prop="equal"></el-table-column>
        <el-table-column label="增量" prop="increment"></el-table-column>
        <el-table-column label="输入时间" prop="entrytime"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="preUpdate(scope.row)">更新</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加存量的弹出框 -->
      <el-dialog
        title="提示"
        :visible.sync="insertScoreInfoVisable"
        width="30%"
      >
        <el-form :model="score_info" :rules="rules" ref="update" label-width="100px">
          <el-form-item label="分值" prop="score">
          <el-select v-model="score_info.score" placeholder="请选择分值">
            <el-option label="45分" value="45"></el-option>
            <el-option label="40分" value="40"></el-option>
            <el-option label="68分" value="68"></el-option>
            <el-option label="67+分" value="67+"></el-option>
            <el-option label="67分" value="67"></el-option>
            <el-option label="66+分" value="66+"></el-option>
            <el-option label="66分" value="66"></el-option>
            <el-option label="65+分" value="65+"></el-option>
            <el-option label="65分" value="65"></el-option>
            <el-option label="64+分" value="64+"></el-option>
            <el-option label="64分" value="64"></el-option>
            <el-option label="63+分" value="63+"></el-option>
            <el-option label="63分" value="63"></el-option>
            <el-option label="62+分" value="62+"></el-option>
            <el-option label="62分" value="62"></el-option>
            <el-option label="61+分" value="61+"></el-option>
            <el-option label="61分" value="61"></el-option>
            <el-option label="60+分" value="60+"></el-option>
            <el-option label="60分" value="60"></el-option>
            <el-option label="58+分" value="58+"></el-option>
            <el-option label="58分" value="58"></el-option>
            <el-option label="55分" value="55"></el-option>
            <el-option label="53分" value="53"></el-option>
            <el-option label="50分" value="50"></el-option>
            <el-option label="35分" value="35"></el-option>
            <el-option label="30分" value="30"></el-option>
            <el-option label="91分" value="91"></el-option>
            <el-option label="92分" value="92"></el-option>
            <el-option label="93分" value="93"></el-option>
            <el-option label="94分" value="94"></el-option>
            <el-option label="95分" value="95"></el-option>
            <el-option label="96分" value="96"></el-option>
            <el-option label="97分" value="97"></el-option>
            <el-option label="98分" value="98"></el-option>
            <el-option label="UNC92分" value="UNC92"></el-option>
            <el-option label="UNC97分" value="UNC97"></el-option>
            <el-option label="UNC98分" value="UNC98"></el-option>
            <el-option label="sp40" value="sp40"></el-option>
            <el-option label="sp45" value="sp45"></el-option>
            <el-option label="sp50" value="sp50"></el-option>
            <el-option label="sp53" value="sp53"></el-option>
            <el-option label="sp55" value="sp55"></el-option>
            <el-option label="sp58" value="sp58"></el-option>
            <el-option label="sp58+" value="sp58+"></el-option>
            <el-option label="sp60" value="sp60"></el-option>
            <el-option label="sp60+" value="sp60+"></el-option>
            <el-option label="sp61" value="sp61"></el-option>
            <el-option label="sp61+" value="sp61+"></el-option>
            <el-option label="sp62" value="sp62"></el-option>
            <el-option label="sp62+" value="sp62+"></el-option>
            <el-option label="sp63" value="sp63"></el-option>
            <el-option label="sp63+" value="sp63+"></el-option>
            <el-option label="sp64" value="sp64"></el-option>
            <el-option label="sp64+" value="sp64+"></el-option>
            <el-option label="sp65" value="sp65"></el-option>
            <el-option label="sp65+" value="sp65+"></el-option>
            <el-option label="sp66" value="sp66"></el-option>
            <el-option label="sp66+" value="sp66+"></el-option>
            <el-option label="sp67" value="sp67"></el-option>
            <el-option label="sp67+" value="sp67+"></el-option>
            <el-option label="sp68" value="sp68"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="当前存量" prop="name">
            <el-input v-model="score_info.equal"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="insertScoreInfoVisable = false">取 消</el-button>
          <el-button type="primary" @click="insertScoreInfo">提 交</el-button>
        </span>
      </el-dialog>

      <!-- 修改的弹出框 -->
      <el-dialog
        title="提示"
        :visible.sync="updateScoreInfoVisable"
        width="30%"
      >
        <el-form :model="score_info" :rules="rules" ref="update" label-width="100px">
          <el-form-item label="当前存量" prop="name">
            <el-input v-model="score_info.equal"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="updateScoreInfoVisable = false">取 消</el-button>
          <el-button type="primary" @click="updateScoreInfo">提 交</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "AdminScore",
  data() {
    return {
      score_info: {},
      cate1List: [],
      cate2List: [],
      tableList: [],
      insertScoreInfoVisable: false,
      updateScoreInfoVisable: false,
      rules: {
        cate1: [
          { required: true, message: "请选择正确的系列", trigger: "blur" },
        ],
        cate2: [
          { required: true, message: "请选择正确的品名", trigger: "blur" },
        ],
        score: [
          { required: true, message: "请选择正确的分值", trigger: "blur" },
        ],
        equal: [
          { required: true, message: "请输入正确的数字", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getCate1List();
  },
  methods: {
    getCate1List() {
      request.get("/common/getCate1List", {}).then((res) => {
        this.cate1List = res.data;
      });
    },
    getCate2List(cate1id) {
      request
        .get("/common/getCate2List", {
          params: {
            id: cate1id,
          },
        })
        .then((res) => {
          this.cate2List = res.data;
        });
    },
    resetForm() {
      this.score_info.equal = ""
      this.updateScoreInfoVisable = false
      this.insertScoreInfoVisable = false
      this.search()
    },
    preInsert(row) {

    },
    preUpdate(row) {
      this.score_info.score = row.score
      this.updateScoreInfoVisable = true

    },
    updateScoreInfo() {
      if (this.score_info.cate1_id == null || this.score_info.cate2_id == null || this.score_info.score == null || this.score_info.equal == null) {
        this.$message({
              type: "error",
              message: '请勿提交空值！！！',
            });
          return
      }
      request.put("/admin/score", this.score_info).then((res) => {
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.resetForm();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
    },
    insertScoreInfo() {
      if (this.score_info.cate1_id == null || this.score_info.cate2_id == null || this.score_info.score == null || this.score_info.equal == null) {
        this.$message({
              type: "error",
              message: '请勿提交空值！！！',
            });
          return
      }
      request.post("/admin/score", this.score_info).then((res) => {
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.resetForm();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
    },
    search() {
      if (this.score_info.cate1_id == null || this.score_info.cate2_id == null) {
        this.$message({
              type: "error",
              message: '请选择系列和品名！',
            });
          return
      }
      request
        .get("/admin/score/getCate2ById", {
          params: {
            cate2_id: this.score_info.cate2_id,
          },
        })
        .then((res) => {
          if (res.code == "0") {
            this.tableList = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
</style>
